import React from 'react';

import { Alert } from '@gogame/components';

const WarningStatus = () => {
  return (
    <Alert severity={'warning'}>
      Moving the campaign to another affiliate you need to set the date for
      statistics start collection.
    </Alert>
  );
};

export default WarningStatus;
